/*************************************************/
/* Partials                                      */
/*************************************************/
import { news } from "./partials/news.js";

/*************************************************/
/* Global variables                              */
/*************************************************/
const $body = $("body"),
    bodyLoadingClass = "is-loading",
    currentCulture = $("html").attr("lang");

/*************************************************/
/* Init                                          */
/*************************************************/
$(document).ready(function () {
    news($body, bodyLoadingClass, currentCulture);
});